import { AmbientLight, Color, MathUtils, Scene, Vector3 } from "three";
import { Cube } from "../objects/Cube";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { CameraController } from "../../componets3D/CameraController";

import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { CharcterOxxo } from "../objects/CharacterOxxo";
// import { MapOxxoMain } from "../objects/MapOxxoMain";
import { MapSubtopicOne } from "../objects/Tema5/MapSubtopicOne";
import { audiosAssets } from "../../../assets/audio";

export class SceneIntroduction extends Scene {
	constructor(loadingManager, container, render, selectedCharacterIntroduction = {
		after: -1,
		before: -1
	}) {
		super();
		this.render = render;
		this.container = container;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.background = new Color(0x04337a);
		this.mouseEvents = new MouseEvents(this.container, this.render, this.camera, this);
		this.selectCharacter = null
		this.selectedCharacterIntroduction = selectedCharacterIntroduction
		this.create();
		this.loadModels();
		this.light();
		this.listeners();
		this.idCharacterSelected = 0;
		this.sceneAppMethod = null
		// this.helper();

		//
		this.renderAnimations();
		this.mouseListeners();
	}

	listeners() {
		ObserverEmitter.on(EVENTS.init_instructions, () => {
			this.characterAndatti.visible = true;
			this.characterCel.visible = true;
			this.characterPremia.visible = true;
			this.characterSpin.visible = true;
		});

		ObserverEmitter.on(EVENTS.final_instructions, () => {
			this.characterAndatti.visible = false;
			this.characterCel.visible = false;
			this.characterPremia.visible = false;
			this.characterSpin.visible = false;

			switch (this.idCharacterSelected) {
				case 1:
					this.selectCharacter.MarcadorAndatti.visible = false;
					break;
				case 2:
					this.characterCel.MarcadorCel.visible = false;
					break;
				case 3:
					this.selectCharacter.MarcadoPremia.visible = false;
					break;
				case 4:
					this.selectCharacter.MarcadorSpin.visible = false;
					break;

				default:
					break;
			}
		});

		ObserverEmitter.on(EVENTS.move_escritorio_introduction, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -0.86;
				this.camera.control.minAzimuthAngle = -2;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.selectCharacter.visible = true
				this.selectCharacter.position.set(-10.5846, -0.9809, -1.9341);
				this.selectCharacter.rotation.set(0, -1.5145, 0);

			});
		});
	}

	create() {
		// this.mapmenu = new MapOxxoMain(this.loadingManager);
		// this.add(this.mapmenu);

		this.mapmenu = new MapSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.characterAndatti = new CharcterOxxo(this.loadingManager, 1, { x: -12.7326, y: -0.97, z: 2.6906 }, { x: 0, y: 0.3382, z: 0 }, 0.1);
		this.add(this.characterAndatti);
		this.characterCel = new CharcterOxxo(this.loadingManager, 2, { x: -13.2953, y: -0.97, z: 3.0808 }, { x: 0, y: 0.669, z: 0 }, 0.1);
		this.add(this.characterCel);
		this.characterPremia = new CharcterOxxo(this.loadingManager, 3, { x: -12.0516, y: -0.97, z: 2.6906 }, { x: 0, y: -0.3235, z: 0 }, 0.1);
		this.add(this.characterPremia);
		this.characterSpin = new CharcterOxxo(this.loadingManager, 4, { x: -11.5833, y: -0.97, z: 3.1135 }, { x: 0, y: -0.7646, z: 0 }, 0.1);
		this.add(this.characterSpin);

		// TODO: por que no detecta el modelo???????
	}
	loadModels() {
		this.cube = new Cube(0.8, { x: -12.7113, y: -0.7154, z: 2.6906 }, 0.44, 0x00ff00);
		this.cube.visible = false;
		this.cube2 = new Cube(0.81, { x: -13.3108, y: -0.7154, z: 3.0461 }, 0.44, 0x000011);
		this.cube2.visible = false;
		this.cube3 = new Cube(0.82, { x: -12.0897, y: -0.7154, z: 2.6906 }, 0.44, 0x00f3);
		this.cube3.visible = false;
		this.cube4 = new Cube(0.83, { x: -11.5833, y: -0.7346, z: 3.1135 }, 0.44, 0x29f1ff);
		this.cube4.visible = false;
		this.add(this.cube, this.cube2, this.cube3, this.cube4);
		this.mouseEvents.objectsToValue = [this.cube, this.cube2, this.cube3, this.cube4];
	}

	initSceneVar() {
		this.characterAndatti.visible = true;
		this.characterCel.visible = true;
		this.characterPremia.visible = true;
		this.characterSpin.visible = true;

		// this.mapmenu.puerta.position.z = 34.155296325683594
		this.idCharacterSelected = 0;
		this.characterAndatti.MarcadorAndatti.visible = false;
		this.characterPremia.MarcadoPremia.visible = false;
		this.characterSpin.MarcadorSpin.visible = false;
	}

	SceneInitialState() {
		this.initSceneVar()


		this.characterAndatti.position.set(-12.7326, -0.97, 2.6906)
		this.characterAndatti.rotation.set(0, 0.3382, 0)

		this.characterCel.position.set(-13.2953, -0.97, 3.0808)
		this.characterCel.rotation.set(0, 0.669, 0)

		this.characterPremia.position.set(-12.0516, -0.97, 2.6906)
		this.characterPremia.rotation.set(0, -0.3235, 0)

		this.characterSpin.position.set(-11.5833, -0.97, 3.1135)
		this.characterSpin.rotation.set(0, -0.7646, 0)


		// this.mapmenu.createSceneChange();
		// this.remove(this.cube, this.cube2, this.cube3);



		this.mouseEvents.disposeInteractions();

		this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
			this.camera.enabledOrbitControls();
			this.mouseListeners();
			this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
			this.camera.control.minPolarAngle = MathUtils.degToRad(20);
			this.camera.control.enableRotate = false;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.control.minDistance = 13.5;
			this.camera.control.maxDistance = 13.5;
			this.camera.control.enablePan = false;

			// ObserverEmitter.emit(EVENTS.initIntroduction)

			// this.characterAndatti.helperlight("andatti");
			// this.characterCel.helperlight("cel");
			// this.characterSpin.helperlight("spin");
			// this.characterPremia.helperlight("premia");
		});
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
		// this.helperLight = new HelperLitght("Ambiente dentro", this.ambient);
	}

	onClearAnimationsIdle() {
		this.characterAndatti.onAnimateIdle();
		this.characterCel.onAnimateIdle();
		this.characterSpin.onAnimateIdle();
		this.characterPremia.onAnimateIdle();
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				this.onClearAnimationsIdle();

				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoPersonaje)
				switch (interactions[0].object.name) {
					case "cube-0.8":
						// console.log("andati");
						this.selectCharacter = this.characterAndatti
						this.idCharacterSelected = 1;
						this.selectedCharacterIntroduction.after = 1
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 1);
						localStorage.setItem("character", 1);
						this.characterAndatti.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = true;
						this.characterCel.MarcadorCel.visible = false;
						this.characterPremia.MarcadoPremia.visible = false;
						this.characterSpin.MarcadorSpin.visible = false;
						break;
					case "cube-0.81":
						// console.log("cel");
						this.selectCharacter = this.characterCel
						this.idCharacterSelected = 2;
						this.selectedCharacterIntroduction.after = 2
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 2);
						localStorage.setItem("character", 2);
						this.characterCel.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = false;
						this.characterCel.MarcadorCel.visible = true;
						this.characterPremia.MarcadoPremia.visible = false;
						this.characterSpin.MarcadorSpin.visible = false;
						break;
					case "cube-0.82":
						// console.log("premia");
						this.selectCharacter = this.characterPremia
						this.idCharacterSelected = 3;
						this.selectedCharacterIntroduction.after = 3
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 3);
						localStorage.setItem("character", 3);
						this.characterPremia.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = false
						this.characterCel.MarcadorCel.visible = false;
						this.characterPremia.MarcadoPremia.visible = true;
						this.characterSpin.MarcadorSpin.visible = false;
						break;
					case "cube-0.83":
						// console.log("spin");
						this.selectCharacter = this.characterSpin
						this.idCharacterSelected = 4;
						this.selectedCharacterIntroduction.after = 4
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 4);
						localStorage.setItem("character", 4);
						this.characterSpin.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = false
						this.characterCel.MarcadorCel.visible = false;
						this.characterPremia.MarcadoPremia.visible = false;
						this.characterSpin.MarcadorSpin.visible = true;
						break;
					default:
						break;
				}
			}
		});
	}
	renderAnimations(delta) {
		this.characterAndatti.renderAnimations(delta);
		this.characterCel.renderAnimations(delta);
		this.characterPremia.renderAnimations(delta);
		this.characterSpin.renderAnimations(delta);
	}
}
